import fetchWithTimeout from "./fetchAPI";

/***
 * Send allowed url to the server
 * @param {string} token
 * @param {string} url
 * @returns {Object}}
 */
export async function sendAllowedUrl(token, url) {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  headers.append('token', token);
  const response = await fetchWithTimeout(
    `whitelist`,
    {
      method: "POST",
      cache: "no-cache",
      redirect: "follow",
      credentials: "omit",
      headers,
      body: JSON.stringify({
        origin: url,
      }),
    },
    3000
  );

  return response.json();
}

/***
 * Update allowed url to the server
 * @param {string} token
 * @param {string} url
 * @returns {Object}}
 */
export async function updateAllowedUrl(token, item) {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  headers.append('token', token);
  const response = await fetchWithTimeout(
    `whitelist`,
    {
      method: "PUT",
      cache: "no-cache",
      redirect: "follow",
      credentials: "omit",
      headers,
      body: JSON.stringify(item),
    },
    3000
  );

  return response.json();
}

/***
 * Get allowed url from the server
 * @param {string} token
 * @returns {string[]}
 */
export async function getAllowedUrls(token) {
  const headers = new Headers();
  headers.append("token", token);
  const response = await fetchWithTimeout(
    `whitelist`,
    {
      method: "GET",
      headers: headers,
      cache: "no-cache",
      redirect: "follow",
      credentials: "omit",
    },
    3000
  );
  return response.json();
}

/***
 * Delete allowed url from the server
 * @param {string} token
 * @param {string} id
 * @returns {boolean}
 */
export async function deleteAllowUrl(token, id) {
  const headers = new Headers();
  headers.append("token", token);
  const response = await fetchWithTimeout(
    `whitelist/${id}`,
    {
      method: "DELETE",
      headers: headers,
      cache: "no-cache",
      redirect: "follow",
      credentials: "omit",
    },
    3000
  );
  return response.status === 200;
}

